import { render, staticRenderFns } from "./ContentViewSettingsGroups.vue?vue&type=template&id=5065efcd&scoped=true&"
import script from "./ContentViewSettingsGroups.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsGroups.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewSettingsGroups.vue?vue&type=style&index=0&id=5065efcd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5065efcd",
  null
  
)

export default component.exports